import {
  useState,
  useCallback,
} from 'react';

import { useIsMountedRef } from '@powdr/hooks';

/**
 * @typedef   {Object}    TabState
 * @property  {Object}    tabValues       the state object containing the tab values
 * @property  {Function}  setTabValues    the tab values updater function
 * @property  {string}    buttonLink     the query string to append to external URLs
 * @property  {string}    setButtonLink  the query string updater function
 */

/**
 * A shared hook that manages/controls the values of the fields rendered by a tab
 * @returns {TabState} a tuple of the state and state update function
 */
export const useWidgetState = () => {
  const [tabValues, setTabValues] = useState({});
  const [buttonLink, setButtonLink] = useState('');
  const isMountedRef = useIsMountedRef();

  return {
    tabValues,
    setTabValues: useCallback((updatedState) => {
      if (!isMountedRef.current) return;
      setTabValues((prevState) => ({ ...prevState, ...updatedState }));
    }, []),
    buttonLink,
    setButtonLink: useCallback((updatedQueryString) => {
      if (!isMountedRef.current) return;
      setButtonLink(updatedQueryString);
    }, []),
  };
};
